import React from 'react';
import { useTranslation } from 'react-i18next';
import { PapiGallection } from '@wix/da-papi-types';
import FollowingWatchIcon from '@wix/da-ds/pkg/Icons/16x16/FollowingWatch';
import PremiumGalleryIcon from '@wix/da-ds/pkg/Icons/16x16/PremiumGallery';
import SimpleTooltip from '@wix/da-ds/pkg/tooltips/dsPreset/SimpleTooltip';
import { normalizePremiumFolderData } from '@wix/da-shared-react/pkg/utils/normalizePremiumFolderData';

import s from './GallerySuffixIcon.scss';

interface Props {
  gallery: PapiGallection;
}

const GallerySuffixIcon: React.FC<Props> = ({ gallery }) => {
  const { t } = useTranslation();
  const { isPremium, isWatchToAccess } = normalizePremiumFolderData(gallery.premiumFolderData);

  if (isWatchToAccess) {
    return (
      <SimpleTooltip text={t('deviationSubmit.form.galleries.watchersOnly.tooltip')}>
        <FollowingWatchIcon className={s['watchers-only-icon']} disableDefaultColors />
      </SimpleTooltip>
    );
  }
  if (isPremium) {
    return (
      <SimpleTooltip text={t('deviationSubmit.form.galleries.premiumFolder.tooltip')}>
        <PremiumGalleryIcon className={s['premium-gallery-icon']} disableDefaultColors />
      </SimpleTooltip>
    );
  }
  return undefined;
};
GallerySuffixIcon.displayName = 'GallerySuffixIcon';

export default GallerySuffixIcon;
